import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=85589fb6&"
import script from "./TransferModal.vue?vue&type=script&lang=ts&"
export * from "./TransferModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports